<div class="info-view">
  <div
    class="info-view__title"
    [ngClass]="isDesktop ? 'text_heading-4' : 'text_heading-5'"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
  >
    {{ data?.title }}
  </div>

  <app-field
    class="info-view__context"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [typeName]="'parse-links'"
    [noUnderline]="true"
    [value]="data?.contentText"
    [size]="tuiElementLargeSize"
  ></app-field>

  <div class="info-view__contacts">
    <div *ngFor="let contact of data?.contacts" class="contacts">
      <app-field
        *ngIf="contact.contact"
        class="field"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [typeId]="contact.contactTypeId"
        [name]="contact.description"
        [value]="contact.contact"
        [size]="tuiElementLargeSize"
      ></app-field>
    </div>
  </div>

  <div class="info-view__buttons">
    <button
      *ngIf="allowEditing$ | async"
      tuiButton
      class="info-view-button"
      tabindex="1"
      type="button"
      [appearance]="'primary'"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="onClickEditButton()"
    >
      {{ 'common.buttons.edit' | translate }}
    </button>

    <button
      *ngIf="allowDeleting$ | async"
      tuiButton
      class="info-view-button"
      tabindex="2"
      type="button"
      [appearance]="'accent'"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [size]="tuiElementLargeSize"
      (click)="onClickDeleteButton()"
    >
      {{ 'common.buttons.delete' | translate }}
    </button>
  </div>
</div>
